import React, { useEffect, useRef, useState } from 'react';
import { IPlayerLevel } from 'utils/types';
import { StyledPlayerLevel } from './style';
import { calculateTimeLeftLabel } from 'templates/PlayerLevel/utils';
import { Box } from '@mui/material';

const ENDS_IN_TEXT = 'ENDS IN: ';

export const CashmanCasinoTimerPlayerLevel: React.FC<IPlayerLevel> = ({
  endsIn = 0,
  assetUrl,
  onTimerDoneHandler,
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const [aspectRatio, setAspectRatio] = useState<number | null>(null);
  const [timerText, setTimerText] = useState<string | undefined>(
    endsIn
      ? calculateTimeLeftLabel({
          text: ENDS_IN_TEXT,
          endsIn,
          onTimerDoneHandler,
        })
      : undefined,
  );

  useEffect(() => {
    const timer = setInterval(() => {
      setTimerText(
        calculateTimeLeftLabel({
          text: ENDS_IN_TEXT,
          endsIn,
          onTimerDoneHandler,
        }),
      );
    }, 1000);

    return () => clearInterval(timer);
  }, [endsIn]);

  useEffect(() => {
    const img = new Image();
    img.src = assetUrl;
    img.onload = () => {
      setAspectRatio(img.width / img.height);
    };
  }, []);

  useEffect(() => {
    if (ref.current && aspectRatio) {
      const width = ref.current.offsetWidth;
      ref.current.style.height = `${width / aspectRatio}px`;
    }
  }, [aspectRatio, timerText]);

  if (!timerText) return <></>;

  return (
    <StyledPlayerLevel
      className={'player-level timer'}
      backgroundUrl={assetUrl}
      ref={ref}
    >
      {timerText && <div className="timer-text">{timerText}</div>}
    </StyledPlayerLevel>
  );
};
